"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductService = exports.Product = void 0;
const token_service_1 = require("./token.service");
const core_1 = require("@angular/core");
const data_source_1 = require("./data-source");
class Product {
    constructor(params) {
        Object.assign(this, params);
        this.setDataSources();
    }
    // Set all data sources for the model
    setDataSources() {
        this.dataSources = this.dataSources.map(dataSource => { return new data_source_1.DataSource(dataSource); });
    }
    // Retrieve the first data source
    getCurrentDataSource() {
        return this.dataSources[0];
    }
}
exports.Product = Product;
let ProductService = class ProductService {
    constructor(_http) {
        this._http = _http;
        this.productURL = '/product';
    }
    pull() {
        return this._http.get(this.productURL)
            .toPromise()
            .then(response => {
            this.products = JSON.parse(response._body).map(product => { return new Product(product); });
        }).catch(err => {
            this.products = null;
            return err;
        });
    }
    get() {
        return this.products;
    }
};
exports.ProductService = ProductService;
exports.ProductService = ProductService = __decorate([
    (0, core_1.Injectable)(),
    __metadata("design:paramtypes", [token_service_1.TokenService])
], ProductService);
//# sourceMappingURL=product.service.js.map